export default __webpack_public_path__ + "img/tab3s-e3351e89.png";